import React, { Component } from "react";
import { connect } from "react-redux";
import { get, put } from "../../utils/request";
import { jumpUrl } from "../../utils/tool";
import "./style.css";
class ArticleDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
    };
  }
  componentWillMount() {
    this.requestArticleDetail();
    this.requestArticleHits();
    this.requestArticlePay();
  }
  render() {
    const { data } = this.state;
    return data != null ? (
      <div className="article_detail_box">
        <div className="article_detail_box_title">{data.title}</div>
        {data.articleType === 2 ? (
          <video
            autoPlay="autoplay"
            className="article_detail_box_video"
            controls
            src={data.videoUrl}
          ></video>
        ) : (
          <div></div>
        )}
        <div
          className="article_detail_box_content"
          dangerouslySetInnerHTML={{ __html: data.articleContent }}
        ></div>
        <div
          className="article_detail_box_ad"
          dangerouslySetInnerHTML={{ __html: data.adContent }}
        ></div>
      </div>
    ) : (
      ""
    );
  }

  /**
   * 请求分享的配置
   */
  requestShareConfig = (article) => {
    const url = window.location.href;
    get("/api/share/config?url=" + url).then((res) => {
      if (res.status === "success") {
        let signature = res.data.signature;
        let timestamp = res.data.timestamp;
        let noncestr = res.data.nonceStr;
        let appid = res.data.appId;
        window.wx.config({
          debug: false, // 开启调试模式,调用的所有public/v1的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: appid, // 必填，公众号的唯一标识
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: noncestr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名
          jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline"], // 必填，需要使用的JS接口列表
        });

        window.wx.ready(function () {
          //分享给朋友
          window.wx.onMenuShareAppMessage({
            title: article.title, // 分享标题
            desc: "一站式升学、就业规划，找浙考之家", // 分享描述
            link: url, // 分享.链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: article.titleImg, // 分享图标s
            type: "link", // 分享类型,music、video或link，不填默认为link
            dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              // 用户确认分享后执行的回调函数
              //                 alert("OK");
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              //                 alert("fail");
            },
          });
          //分享给朋友圈
          window.wx.onMenuShareTimeline({
            title: article.title, // 分享标题
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: article.titleImg, // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
            },
          });
        });
      }
    });
  };
  /**
   * 请求专业列表
   */
  requestArticlePay = () => {
    const hashId = this.props.match.params.hashId;
    get("/public/v1/article/pay/" + hashId).then((res) => {
      if (res.data === true) {
        this.requestIsBuy();
      }
    });
  };
  /**
   * 获取用户是否购买的标识
   */
  requestIsBuy = () => {
    get("/public/v1/user/isBuy").then((res) => {
      if (res.data === false) {
        jumpUrl("pay");
      }
    });
  };
  /**
   * 请求专业列表
   */
  requestArticleDetail = () => {
    const hashId = this.props.match.params.hashId;
    get("/public/v1/article/detail/" + hashId).then((res) => {
      let dataSource = res.data;
      this.setState({
        data: dataSource,
      });
      this.requestShareConfig(res.data);
    });
  };

  /**
   * 增加文章阅读数
   */
  requestArticleHits = () => {
    const hashId = this.props.match.params.hashId;
    put("/public/v1/article/hits/" + hashId).then((res) => {});
  };
}
const mapStateToProps = (state) => {
  return {
    userInfo: state.user.userData.userInfo,
  };
};

export default connect(mapStateToProps)(ArticleDetail);



// WEBPACK FOOTER //
// ./src/containers/ArticleDetail/index.js